'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaymentOption = function (_Component) {
    _inherits(PaymentOption, _Component);

    function PaymentOption(props) {
        _classCallCheck(this, PaymentOption);

        var _this = _possibleConstructorReturn(this, (PaymentOption.__proto__ || Object.getPrototypeOf(PaymentOption)).call(this, props));

        _this.preventDoubleClick = function (event) {
            event.preventDefault();
            var _this$props = _this.props,
                disabled = _this$props.disabled,
                onDisable = _this$props.onDisable;


            if (!disabled) {
                window.location = _this.props.paymentUrl;

                onDisable();
            }

            return false;
        };

        _this.timer = undefined;
        return _this;
    }

    _createClass(PaymentOption, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                currency = _props.currency,
                theme = _props.theme,
                target = _props.target,
                productId = _props.productId,
                title = _props.title,
                price = _props.price,
                priceDetail = _props.priceDetail,
                paymentUrl = _props.paymentUrl,
                bannerText = _props.bannerText,
                additionalClassName = _props.additionalClassName,
                buyButtonText = _props.buyButtonText,
                disabled = _props.disabled;

            var buttonText = disabled ? 'Vent litt...' : buyButtonText;

            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)(theme.option, additionalClassName),
                    'data-test-tag': '@vg/salesposter:payment'
                },
                bannerText && _react2.default.createElement(
                    'div',
                    { className: theme.banner },
                    bannerText
                ),
                _react2.default.createElement(
                    'a',
                    {
                        href: paymentUrl,
                        className: (0, _classnames2.default)(theme.buylink),
                        'data-product-id': productId,
                        onClick: function onClick(event) {
                            return target === 'app' && _this2.preventDoubleClick(event);
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: theme.content },
                        _react2.default.createElement(
                            'div',
                            { className: theme.title },
                            title
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: theme.price },
                            _react2.default.createElement(
                                'span',
                                { className: theme.currency },
                                currency,
                                ' '
                            ),
                            price
                        ),
                        priceDetail && _react2.default.createElement(
                            'div',
                            { className: theme.priceDetail },
                            priceDetail
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: theme.buyButton },
                            buttonText
                        )
                    )
                )
            );
        }
    }]);

    return PaymentOption;
}(_react.Component);

PaymentOption.propTypes = {
    currency: _propTypes2.default.string.isRequired,
    theme: _propTypes2.default.shape({}),
    target: _propTypes2.default.string.isRequired,
    productId: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    price: _propTypes2.default.string.isRequired,
    priceDetail: _propTypes2.default.string,
    buyButtonText: _propTypes2.default.string.isRequired,
    paymentUrl: _propTypes2.default.string.isRequired,
    bannerText: _propTypes2.default.string,
    additionalClassName: _propTypes2.default.string,
    disabled: _propTypes2.default.bool.isRequired,
    onDisable: _propTypes2.default.func.isRequired
};
PaymentOption.defaultProps = {
    theme: {},
    priceDetail: '',
    bannerText: '',
    additionalClassName: '',
    disabled: false
};
exports.default = PaymentOption;
//# sourceMappingURL=PaymentOption.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/salesposter/lib/cjs/PaymentOption.js
 ** module id = 738
 ** module chunks = 1
 **/